import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  sendRequestToBMC,
  getBMCTemplates,
  getBMCList,
  setBMCTemplates,
  setSendRequestToBMCDetails,
  resetData,
} from "src/redux/slices/civilDefenseSlice";

import "./SendRequestToBMC.scss";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { ReactComponent as ExportNotesIcon } from "src/assets/icons/export_notes.svg";
import { MAX_TEXT_FIELD_SIZE } from "src/resources/constant";
import { getFieldName, isNullOrWhiteSpace } from "src/utils/helpers";
import { useEffect } from "react";
import useOnPageLeave from "src/hooks/useOnPageLeave";
import { useCallback } from "react";

const SendRequestToBMC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["civilDefense"]);
  const onPageLeave = useCallback(() => {
    dispatch(resetData());
  }, []);

  useOnPageLeave(onPageLeave);
  // useOnPageLeave(resetData);
  const breadCrumbsPaths = useSelector(
    (state: any) => state.breadCrumb.breadCrumbItems
  );
  const bmcList = useSelector((state: any) => state.civilDefense.bmcList);
  const requestToBMCData = useSelector(
    (state: any) => state.civilDefense.requestToBMCData
  );
  const bmcTemplates = useSelector(
    (state: any) => state.civilDefense.bmcTemplates
  );
  // useEffect(() => {
  //   dispatch(getBMCList() as any);
  // }, [dispatch]);

  const onSuccess = () => {
    toast.success(t("requestSent"));
    dispatch(resetData() as any);
    //successCallbackFn?.();
  };
  const handleSendRequestToBMC = (e: any): void => {
    e.preventDefault();
    dispatch(sendRequestToBMC(onSuccess) as any);
  };

  const handleFieldChange = (e: any) => {
    var name = "";
    var value = "";
    value = e.target.value;
    name = e.target.name;
    var updatedDetails = { ...requestToBMCData, [name]: value };
    if (name == "templateId") {
      var template = bmcTemplates.find(
        (t: { id: any }) => t.id?.toString() == value?.toString()
      );
      {
        if (template) {
          updatedDetails = { ...updatedDetails, ["body"]: template.body };
          updatedDetails = { ...updatedDetails, ["subject"]: template.subject };
        }
      }
    }

    dispatch(setSendRequestToBMCDetails(updatedDetails));
  };

  const getCompanyTemplates = async () => {
    dispatch(setBMCTemplates([]) as any);
    const resData = await dispatch(
      getBMCTemplates(requestToBMCData.bmcId) as any
    );
  };

  return (
    <div className="">
      <div className="d-flex justify-content-between p-2 px-3">
        {breadCrumbsPaths.length && (
          <h2 className="inner-page-title">
            {t(breadCrumbsPaths[breadCrumbsPaths.length - 1].label)}
          </h2>
        )}
      </div>
      <div className={`registration-form-wrapper cd-send-request-wrapper`}>
        <div className={`registration-form`}>
          <form>
            <div className="pt-3">
              <div className="form-group d-flex flex-column mb-3">
                <label htmlFor="bmcId" className="required">
                  {t("bmcs")}
                </label>
                <Dropdown
                  id="bmcId"
                  name="bmcId"
                  value={requestToBMCData.bmcId}
                  optionValue={"id"}
                  optionLabel={"name"}
                  onChange={handleFieldChange}
                  options={bmcList}
                  placeholder={t("company")}
                  className="mb-2"
                  panelClassName="status-dropdown-panel"
                  onBlur={async () => {
                    if (!isNullOrWhiteSpace(requestToBMCData.bmcId)) {
                      await getCompanyTemplates();
                    }
                  }}
                />
              </div>

              <div
                className={`form-group d-flex flex-column mb-3 ${
                  isNullOrWhiteSpace(requestToBMCData.bmcId) ? "disabled" : ""
                }`}
              >
                <label htmlFor="templateId">{t("template")}</label>
                <Dropdown
                  id="templateId"
                  name="templateId"
                  value={requestToBMCData.templateId}
                  optionValue={"id"}
                  optionLabel={"name"}
                  onChange={handleFieldChange}
                  options={bmcTemplates}
                  placeholder={t("selectTemplate")}
                  className=" mb-2"
                  disabled={isNullOrWhiteSpace(requestToBMCData.bmcId)}
                  panelClassName="status-dropdown-panel"
                />
              </div>
              <div className="form-group d-flex flex-column mb-3">
                <label htmlFor="subject" className="required">
                  {t("subject")}
                </label>
                <InputText
                  id="subject"
                  name="subject"
                  placeholder={t("subjectPlaceHolder")}
                  className="mb-2"
                  value={requestToBMCData.subject}
                  onChange={handleFieldChange}
                  maxLength={MAX_TEXT_FIELD_SIZE}
                />
              </div>

              <div className="form-group d-flex flex-column">
                <label htmlFor="body" className="required">
                  {t("body")}
                </label>
                <InputTextarea
                  id="body"
                  name="body"
                  className="mb-2 w-100"
                  placeholder={t("bodyPlaceHolder")}
                  value={requestToBMCData.body}
                  onChange={handleFieldChange}
                  rows={10}
                />
              </div>
              <div className="d-flex justify-content-end align-items-center gap-2 mt-4 send-request-to-owner-footer">
                <Button
                  label={t("sendRequest")}
                  className="edit-btn primary-btn m-0"
                  icon={<ExportNotesIcon />}
                  onClick={handleSendRequestToBMC}
                  disabled={
                    isNullOrWhiteSpace(requestToBMCData.bmcId) ||
                    isNullOrWhiteSpace(requestToBMCData.subject) ||
                    isNullOrWhiteSpace(requestToBMCData.body)
                  }
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SendRequestToBMC;
